<script>
// import axios from 'axios'
// import qs from 'qs'

import CustomerList from "@/components/admin/common/list/CustomerList.vue"
import Title from "@/components/admin/common/TitleArea.vue"

export default {
  name: "Admin-Customer-management",
  meta: {
    title: "어드민-고객정보조회"
  },
  components: {
    CustomerList,
    Title,
  },
  data() {
    return {
      description   : {
        title : '전체고객 정보조회'
      },
      inqCustomerType : 'all'
    }
  },
  methods:{}
}
</script>

<template>

  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        
        <Title
          :desc="description">
          <q-btn-group>
            <q-btn
              :color="inqCustomerType === 'all' ? 'primary': 'grey'"
              size="md"
              label="전체"
              @click="() => { inqCustomerType = 'all'; description.title = '전체고객 정보조회'}"/>
            <q-btn
              :color="inqCustomerType === 'partner' ? 'secondary': 'grey'"
              size="md"
              label="파트너사"
              @click="() => { inqCustomerType = 'partner'; description.title = '파트너사 정보조회'}"/>
            <q-btn
              :color="inqCustomerType === 'customer' ? 'info': 'grey'"
              size="md"
              label="일반고객"
              @click="() => { inqCustomerType = 'customer'; description.title = '일반고객 정보조회'}"/>
          </q-btn-group>
        </Title>  

      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box">
          <CustomerList
            :type="inqCustomerType" />
        </div>
      </div>
    </div>
  </q-page>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>